import React, { useEffect, useState } from "react"
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material"
import * as Style from "./Style"
import Button from "@mui/material/Button"
import MenuItem from "@mui/material/MenuItem"
import {
  useGetCountrysQuery,
  useGetServiceProvierQuery,
} from "../../features/Auth/authApi"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import { useAppSelector } from "../../app/hooks"
import { useAppDispatch } from "../../app/store"
import { setString } from "../../features/Auth/WrapperSlice"
import { createFilterOptions } from "@mui/material/Autocomplete"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"

interface PersonalAccount {
  services: (string | undefined)[]
  language: (string | undefined)[]
  experience: string
}

const Experience = [
  {
    value: "0",
    label: "Less Than 1 Year",
  },
  {
    value: "1",
    label: "1 Year",
  },
  {
    value: "2",
    label: "2 Years",
  },
  {
    value: "3",
    label: "3 Years",
  },
  {
    value: "4",
    label: "4 Years",
  },
  {
    value: "5",
    label: "5 Years",
  },
  {
    value: "6",
    label: "6 Years",
  },
  {
    value: "7",
    label: "7 Years",
  },
  {
    value: "8",
    label: "8 Years",
  },
  {
    value: "9",
    label: "9 Years",
  },
  {
    value: "10",
    label: "10 Years",
  },
  {
    value: "11",
    label: "11 Years",
  },
  {
    value: "12",
    label: "12 Years",
  },
  {
    value: "13",
    label: "13 Years",
  },
  {
    value: "14",
    label: "14 Years",
  },
  {
    value: "15",
    label: "15 Years",
  },
  {
    value: "Above 15",
    label: "Above 15 Years",
  },
]

interface PersonalStepProps {
  activeStep: string
  step: string
  handleNext: () => void
  handleBack: () => void
}

const ServiceStep: React.FC<PersonalStepProps> = ({
  activeStep,
  step,
  handleNext,
  handleBack,
}) => {
  const { data: servicePost } = useGetServiceProvierQuery({})
  const dispatch = useAppDispatch()
  const [experienceAdd, setExperienceAdd] = useState("")
  const [isFocused, setIsFocused] = useState(false)
  const filter = createFilterOptions<string>()

  const schemaResolver = yupResolver(
    yup.object().shape({
      services: yup
        .array()
        .of(yup.string())
        .min(1, "Please Select At Least One Services")
        .required("Please Select Services"),
      language: yup
        .array()
        .of(yup.string())
        .min(1, "Please Select At least One language")
        .max(3, "Please Select Up To 3 Languages")
        .required("Please Select Languages"),
      experience: yup.string().required("Please Select Experience."),
    }),
  )

  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<PersonalAccount>({
    resolver: schemaResolver,
  })
  const stringValue = useAppSelector((state) => state?.wrapper?.stringValue)
  const { data: countryList } = useGetCountrysQuery({})

  const onSubmit = (value: any) => {
    dispatch(
      setString({
        ...stringValue,
        services: value?.services,
        languageAll: value?.language,
        experience: value?.experience,
      }),
    ),
      handleNext()
  }

  useEffect(() => {
    setValue("services", (stringValue as any)?.services)
    setValue("language", (stringValue as any)?.languageAll)
    setValue("experience", (stringValue as any)?.experience)
  }, [stringValue])

  const Experiencehandle = (e: any) => {
    setExperienceAdd(e?.target?.value)
  }

  return (
    <Style.PersonalInfo className="p-5">
      <Box className="d-flex justify-content-center align-items-center">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography sx={{ mt: 2, mb: 2 }}>
            <Box
              component="form"
              sx={{
                "& > :not(style)": { mb: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <InputLabel sx={{ mb: 0 }} htmlFor="outlined-basic">
                Services<span className="text-danger">*</span>
              </InputLabel>
              <FormControl
                sx={{
                  mb: 1,
                  width: 300,
                  " & .form-input": {
                    width: "400px",
                    borderRadius: "34px",
                    backgroundColor: "white",
                  },
                }}
              >
                <InputLabel id="language-label">Services</InputLabel>
                <Select
                  labelId="language-label"
                  className="form-input"
                  label="services"
                  multiple
                  id="demo-simple-select"
                  {...register("services" as any)}
                  value={watch("services" as any) || []}
                  onChange={(event) => {
                    const selectedValues = event.target.value
                    setValue("services" as any, selectedValues as any, {
                      shouldValidate: true,
                    })
                  }}
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      }}
                    >
                      {selected.map((selectedItemId: any) => {
                        const selectedItem = servicePost?.data?.find(
                          (item: any) => item?._id === selectedItemId,
                        )
                        return (
                          <Chip
                            key={selectedItemId}
                            label={selectedItem?.name}
                            onMouseDown={(event) => event.stopPropagation()}
                            onDelete={(event) => {
                              event.stopPropagation()
                              const newValues = selected.filter((id: any) => id !== selectedItemId)
                              setValue("services", newValues, { shouldValidate: true })
                            }}
                            sx={{
                              backgroundColor: "#F475A4",
                              color: "#ffffff",
                              "& .MuiChip-deleteIcon": { color: "#ffffff" },
                            }}
                          />

                        )
                      })}
                    </Box>
                  )}

                  fullWidth
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        width: 150,
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#f07fa9 transparent",
                        borderRadius: "12px",
                        cursor: "pointer",
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                  }}
                >
                  {servicePost?.data &&
                    servicePost?.data?.map((serviceName: any) => (
                      <MenuItem
                        key={serviceName?._id}
                        value={serviceName?._id}
                        sx={{
                          // "&.Mui-selected": {
                          //   backgroundColor: "#F475A4",
                          //   color: "#ffffff",
                          // },
                          "&:hover": {
                            backgroundColor: "#F475A4",
                            color: "#000000",
                          },
                          color: "#000000",
                        }}
                      >
                        <Box
                          sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            maxWidth: "300px",
                            overflowX: "auto",
                          }}
                        >
                          {serviceName?.name}
                        </Box>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <p className="text-danger  m-0">{errors?.services?.message}</p>
            </Box>
          </Typography>

          <Typography sx={{ mb: 1 }}>
            <Box
              component="form"
              sx={{
                "& > :not(style)": { mb: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                Languages<span className="text-danger">*</span>
              </InputLabel>
              <FormControl
                sx={{
                  mb: 1,
                  width: 300,
                  " & .form-input": {
                    width: "400px",
                    borderRadius: "34px",
                    backgroundColor: "white",
                  },
                }}
              >
                <InputLabel id="language-label">Languages</InputLabel>
                <Select
                  labelId="language-label"
                  className="form-input"
                  multiple
                  id="demo-simple-select"
                  {...register("language" as any)}
                  value={watch("language" as any) || []}
                  onChange={(event) => {
                    const selectedValues = event.target.value
                    setValue("language" as any, selectedValues as any, {
                      shouldValidate: true,
                    })
                  }}
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      }}
                    >
                      {selected.map((selectedItemId: any) => {
                        const selectedItem = countryList?.languages?.find(
                          (item: any) => item?.name === selectedItemId,
                        )
                        return (
                          <Chip
                            key={selectedItemId}
                            label={selectedItem?.name}
                            onMouseDown={(event) => event.stopPropagation()}
                            onDelete={(event) => {
                              event.stopPropagation()
                              const newValues = selected.filter((id: any) => id !== selectedItemId)
                              setValue("language", newValues, { shouldValidate: true })
                            }}
                            sx={{
                              backgroundColor: "#F475A4",
                              color: "#ffffff",
                              "& .MuiChip-deleteIcon": { color: "#ffffff" },
                            }}
                          />
                        )
                      })}
                    </Box>
                  )}

                  fullWidth
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        width: 150,
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#f07fa9 transparent",
                        borderRadius: "12px",
                        cursor: "pointer",
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                  }}
                >
                  {countryList?.languages?.map((item: any) => (
                    <MenuItem
                      sx={{
                        // "&.Mui-selected": {
                        //   backgroundColor: "#F475A4",
                        //   color: "#ffffff",
                        // },
                        "&:hover": {
                          backgroundColor: "#F475A4",
                          color: "#000000",
                        },

                        color: "#000000",
                      }}
                      key={item.name}
                      value={item.name}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <p className="text-danger  m-0">{errors?.language?.message}</p>
            </Box>
          </Typography>

          <Typography sx={{ mb: 1 }}>
            <Box
              component="form"
              sx={{
                "& > :not(style)": { mb: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <InputLabel sx={{ mb: 2 }} htmlFor="experience-input">
                Experience<span className="text-danger">*</span>
              </InputLabel>
              <FormControl
                sx={{
                  mb: 1,
                  width: 300,
                  " & .form-input": {
                    width: "400px",
                    borderRadius: "34px",
                    backgroundColor: "white",
                  },
                }}
              >
                <InputLabel id="experience-label">Experience</InputLabel>
                <Select
                  labelId="experience-label"
                  id="experience-input"
                  className="form-input"
                  {...register("experience" as any)}
                  value={watch("experience" as any) || ""}
                  onChange={(event) => {
                    setValue("experience", event.target.value, {
                      shouldValidate: true,
                    })
                  }}
                  fullWidth
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        width: 150,
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#f07fa9 transparent",
                        borderRadius: "12px",
                        cursor: "pointer",
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                  }}
                >
                  {Experience.map((item) => (
                    <MenuItem
                      key={item.label}
                      value={item.label}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#F475A4",
                          color: "#000000",
                        },
                        color: "#000000",
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <p className="text-danger mt-1">{errors?.experience?.message}</p>
            </Box>
          </Typography>

          <Button
            color="inherit"
            disabled={(activeStep as any) === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
            className="next-button me-xl-5 mb-3"
          >
            Back
          </Button>
          <Button type="submit" className="next-button grey-button ms-xl-5">
            {(activeStep as any) === step.length - 1 ? "Finish" : "Next"}
          </Button>
        </form>
      </Box>
    </Style.PersonalInfo>
  )
}

export default ServiceStep
